import ApplicationController from "./application_controller.js";

export default class extends ApplicationController {
	async handleUpload(event) {
		event.preventDefault();
		const form = document.forms["NonStopGov"];
		const fileInput = form.querySelector('input[type="file"]');
		const files = fileInput?.files || [];
		const uploadedFiles = [];
    const button = document.getElementById("fileAddButton");
		const baseUrl = button.dataset.uploadBaseUrl;

		for (let file of files) {

			const fileDescriptionValue = form.fileDescription.value;

			// Check if the string is empty after trimming whitespace
			if (!fileDescriptionValue || fileDescriptionValue.trim() === '') {
			    const userConfirmed = confirm(
            "As you did not provide a document description, we will use the filename instead.\nAre you sure you wish to continue?"
	        );

	        if (!userConfirmed) {
	            return false;
	        }
			}
			// STEP 1: Get presigned URL
      try {
        const response = await fetch(`${baseUrl}/internal/files/upload/presigned-url`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            fileName: file.name,
            fileSize: file.size
          })
        });

        if (response.status === 400) {
                const message = await response.text();
                this.insertNavigableAlert(message);
                return;
            } else if (!response.ok) {
              const errorText = await response.text().catch(() => 'Unknown server error.');
              alert(`Failed to get pre-signed URL for ${file.name}. Details: ${errorText}`);
              return;
          }

        const data = await response.json();
        const presignedUrl = data.preSignedUrl;
        const cdmsDocumentId = data.cdmsDocumentId;

        // STEP 2: Upload to CDMS
        const upload = await fetch(presignedUrl, {
          method: "PUT",
          headers: { "Content-Type": file.type },
          body: file
        });

        if (!upload.ok) {
          alert(`Upload failed for ${file.name}`);
          return;
        }

        // STEP 3: Collect metadata
        uploadedFiles.push({
          cdmsDocumentId,
          fileName: file.name,
          fileType: file.type,
          description: form.fileDescription.value || file.name,
          tags: Array.from(form.fileTags?.selectedOptions || []).map(o => o.value),
          summary: form.querySelector('input[name="fileSummary"]:checked')?.value || "N",
          public: form.querySelector('input[name="filePublic"]:checked')?.value || "N",
          fileLastModified: file.lastModified
        });
			} catch (e) {
         alert("Network error during upload");
         return;
      }
		} // This bracket was missing or misplaced

		// STEP 4: Add hidden input
		let hiddenInput = form.querySelector('input[name="uploadedFiles"]');
		if (!hiddenInput) {
			hiddenInput = document.createElement("input");
			hiddenInput.type = "hidden";
			hiddenInput.name = "uploadedFiles";
			form.appendChild(hiddenInput);
		}
		hiddenInput.value = JSON.stringify(uploadedFiles);
		hiddenInput.removeAttribute("disabled");

		// STEP 5: Remove file input name to prevent multipart submission
		if (fileInput) fileInput.removeAttribute("name");

		// STEP 6: send across in the form attributes we need
		// The names of the elements we want to KEEP enabled and submit
    	const allowedNames = ["uploadedFiles","description", "fileSummary","filePublic","fileLastModified","fileTags","folderId"];
   		 // 1. Target all form elements that are *not* the allowed ones
	    const selectorToDisable = `
	    [name]:not([name="${allowedNames[0]}"]):not([name="${allowedNames[1]}"]),
	    [name][type="hidden"]:not([name="${allowedNames[0]}"]):not([name="${allowedNames[1]}"])`;

	    // Find all these elements in the form
	    const elementsToDisable = form.querySelectorAll(selectorToDisable);

	    // Disable them
	    elementsToDisable.forEach(element => {
	        element.disabled = true;
	    });

    	// 2. Explicitly ensure the fields are enabled (especially useful for radio buttons)
	    allowedNames.forEach(name => {
	        // Select all elements with the allowed name
	        const allowedElements = form.querySelectorAll(`[name="${name}"]`);
	        allowedElements.forEach(element => {
	            element.disabled = false;
	        });
	    });
		// STEP 7: Submit the form
		form.submit();
	} // This bracket was missing or misplaced


	insertNavigableAlert(errorText) {
		const cardBody = document.querySelector('.card-body');
		if (cardBody) {
			let alertDiv = document.getElementById('alertBox');

			if (alertDiv) {
				alertDiv.textContent = errorText;
				alertDiv.className = 'alert alert-danger alert-dismissible fade show';
			} else {

				alertDiv = document.createElement('div');
				alertDiv.id = 'alertBox';
				alertDiv.className = 'alert alert-danger alert-dismissible';
				alertDiv.classList.add('fade', 'show');
				alertDiv.textContent = errorText;
				cardBody.prepend(alertDiv);
			}
		} else {
			console.error('Error: Could not find the .card-body element.');
		}
	}
}
